import React from 'react'
import clsx from 'clsx'
import { Container as ContainerStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import useDeprecatedProps from '../../lib/hooks/useDeprecatedProps'
import { BreakpointName, CommonProps, PolymorphicProps } from '../helperTypes'

const useStyles = createUseStyles(ContainerStyles, 'container')

type Props = {
  /**
   * If true, responsive max-widths will be set for all breakpoints
   */
  fixed?: boolean
  /**
   * If provided, the container will be fullwidth until the given breakpoint
   */
  until?: BreakpointName
}

type DeprecatedProps = {
  fluid?: boolean
}

export type ContainerProps<C extends React.ElementType> = PolymorphicProps<C, Props & DeprecatedProps & CommonProps>

const handleDeprecatedProps = (props: any) => {
  const { fluid, ...rest } = props
  return {
    ...(fluid === false && { fixed: true }),
    ...rest,
  }
}

export const Container = <C extends React.ElementType = 'div'>(props: ContainerProps<C>) => {
  const { className, children, component, fixed = false, until, ...rest } = handleDeprecatedProps(props)
  useDeprecatedProps('Container', { fluid: undefined }, props)
  const ComponentProp = component || 'div'
  const classes = useStyles()

  return (
    <ComponentProp
      className={clsx(className, !fixed && classes.root, fixed && classes.fixed, until && classes[`_until-${until}`])}
      {...rest}
    >
      {children}
    </ComponentProp>
  )
}

export default Container
